import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useParams } from 'react-router';
import { type EnrichedClientDto, getClientDetailsByPartnerUuid } from '../../generated/client';
import { queryKeys } from '../../query-keys';

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const isUuid = (uuid?: string) => !!uuid && uuidRegex.test(uuid);

export function useClient(uuid?: string): UseQueryResult<EnrichedClientDto, AxiosError> {
    const params = useParams<{ partnerUuid: string }>();

    const partnerUuid = uuid || params.partnerUuid;
    const enabled = isUuid(partnerUuid);

    return useQuery({
        queryKey: queryKeys.client(partnerUuid),
        queryFn: ({ signal }) => getClientDetailsByPartnerUuid({ path: { partnerUuid: partnerUuid! }, signal }).then((result) => result.data!),
        enabled,
        refetchOnMount: false,
    });
}
